import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { hannibalConfig } from "./data";

export default function HannibalPage() {
  return <CityPageTemplate config={hannibalConfig} />;
}